import React from 'react';
import Card from '../Card';
import { onRequestPhoneCall } from '../../helpers/validationHelper';

const KeyContactCard = ({ contact }) => (
  <Card
    title="Contact Information"
    body={(
      <>
        <div>{contact.department}</div>
        <div>{contact.email}</div>
        <div>{onRequestPhoneCall(contact.phone)}</div>
        <div>{contact.office}</div>
        
      </>
    )}
  />
);

export default KeyContactCard;
